module.exports = __webpack_public_path__ + "app/admin/metrics/metrics-WEuY_ipV.html";